import React from "react";
import "./About.css";

const About = () => {
  return (
    <>
      <div className='banner'>
        <img src="/Images/about.png" alt="Boltcrew Engineering Factory Banner" />
        <h1 style={{display:"none"}}>BOLTCREW ENGINEERING</h1>
      </div>

      <section className='aboutus-section'>
        <img src="/Images/about2.png" alt="Boltcrew Engineering" />

        <div className="about-text">
          <h2>Empowering Sri Lanka's Sustainable Manufacturing Future</h2>
          <p>
            Botcrew Engineering is a premier provider of integrated sustainable solutions for the manufacturing sector in Sri Lanka. As a strategic subsidiary of John Douglas SG Pte Ltd, we leverage a global network of expertise and procurement power to deliver world-class engineering standards to the local market.
            We specialize in bridging the gap between operational efficiency and environmental responsibility. By supplying genuine OEM mechanical and electrical spare parts—including high-precision bearings, belts, and process equipment components—we ensure your facility runs at peak performance with minimal environmental impact.
            Being part of the John Douglas SG family allows us to combine international technical benchmarks with deep local insight, ensuring our clients receive the most reliable, sustainable, and cost-effective solutions available.
          </p>

          <br />

          <h3>Our Core Solution: Quality & Sustainability</h3>
          <div className="about-text-content">
            <p>
              Manufacturing reliability starts with quality components. Our primary focus is the reliable supply of genuine OEM mechanical and electrical spare parts for essential process equipment.
            </p>
            <ul>
              <li><strong>Precision Components:</strong> We source and deliver critical parts including bearings and belts, ensuring perfect fit and optimal performance to drastically reduce unplanned downtime.</li>
              <li><strong>Integrated Approach:</strong> Our solutions are engineered not just to fix a problem, but to create a more resilient and energy-efficient process, contributing directly to your sustainability goals.</li>
            </ul>
          </div>
        </div>
      </section>

      <section className='values-section'>
        <div className="strategy-grid">
          <div className="strategy-card">
            <h2>Why Partner with Boltcrew?</h2>
            <p>
              As a Sri Lankan company, we are uniquely positioned to provide local expertise with global quality standards. We are more than a supplier; we are a strategic partner committed to supporting your business with expert advice and the timely delivery of world-class parts.
              <br /><br />
              We help your business move from relying on quick fixes to building a lasting, sustainable operational framework.
            </p>
          </div>

          <div className="strategy-card">
            <h2>Driving Efficiency. Delivering Sustainability.</h2>
            <p>
              At Boltcrew Engineering, we know that in the competitive manufacturing sector, every minute of uptime and every degree of efficiency matters. We were founded to address the dual needs of the modern Sri Lankan manufacturer: access to uncompromising OEM quality and a clear path toward operational sustainability.
            </p>
          </div>

        </div>

        <div className="deliverables-box">
          <h2>What We Deliver</h2>
          <p>
            We bridge the gap between process equipment and peak performance by providing Integrated Sustainable Solutions built on the supply of premium spare parts.
          </p>

          <br />

          <div className="cards-container">
            <div className="value-card">
              <h3>OEM Spare Parts Supply</h3>
              <p>
                Guaranteed supply of genuine Mechanical & Electrical parts (e.g., bearings, belts) for maximum equipment reliability and lifespan.
              </p>
            </div>
            <div className="value-card">
              <h3>Reduced Downtime</h3>
              <p>
                Fast, reliable sourcing and local support minimize costly production halts.
              </p>
            </div>
            <div className="value-card">
              <h3>Sustainable Operations</h3>
              <p>
                By supplying quality, durable parts, we help optimize equipment efficiency, reduce waste, and lower your long-term maintenance costs.
              </p>
            </div>
            <div className="value-card">
              <h3>Local Expertise</h3>
              <p>
                As a Sri Lankan company, we provide tailored, prompt service and an in-depth understanding of local industrial needs.
              </p>
            </div>
          </div>
        </div>
      </section>

      <div className="cta-section">
        <p style={{ fontWeight: 'bold', fontSize: '20px' }}>
          Partner with Boltcrew Engineering to secure your supply chain, optimize your assets, and build a truly resilient manufacturing operation.
        </p>
      </div>
    </>
  );
};

export default About;